import { Player } from './player';

export interface CreateRoundRequest {
    name: string;
}

export interface GetRoundRequest {
    id: string;
}

export interface GetRoundResponse {
    id: string;
    name: string;
    date: string;
    status: string;
    players: Player[];
}

export interface Round {
    id: string;
    name: string;
    date: string;
    status: string;
    player?: Player;
    players: Player[];
}

export enum RoundStatus {
    NEW = 'NEW',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED'
}